import * as React from 'react'

import { TextField } from 'main/ui'
import { FieldGroupContainer } from './styles'
import { Container } from './UserFields.styles'

interface IData {
  email: string
  password: string
  firstName: string
  lastName: string
}

interface IValidation {
  email?: string
  password?: string
  firstName?: string
  lastName?: string
}

interface IProps {
  data: IData
  validationHints: IValidation
  onChange: (data: Partial<IData>) => void
}

function UserFields(props: IProps) {
  const { data, validationHints, onChange } = props

  return (
    <Container>
      <TextField
        label="Email"
        placeholder="Enter your email"
        value={data.email}
        onChange={email => onChange({ email })}
        validationHint={validationHints.email}
        required
      />

      <TextField
        type="password"
        label="Password"
        placeholder="Enter a password"
        value={data.password}
        onChange={password => onChange({ password })}
        validationHint={validationHints.password}
        required
      />

      <FieldGroupContainer>
        <TextField
          label="First Name"
          placeholder="Enter your first name"
          value={data.firstName}
          onChange={firstName => onChange({ firstName })}
          validationHint={validationHints.firstName}
          required
        />
        <TextField
          label="Last Name"
          placeholder="Enter your last name"
          value={data.lastName}
          onChange={lastName => onChange({ lastName })}
          validationHint={validationHints.lastName}
          required
        />
      </FieldGroupContainer>
    </Container>
  )
}

export default React.memo(UserFields)
